import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Layout from '../components/Layout'
import { useLoad } from '../hooks/request'
import { format } from '../utils/number'
import { TECH_LIST, TOTAL_EXPENSE_LIST } from '../urls'
import Button from '../components/common/Button'

export default function Home() {
    const [filters, setFilters] = useState({
        date_month: '',
        date_year: new Date().getFullYear(),
    })
    const [showFilters, setShowFilters] = useState(false)
    console.log(setShowFilters)
    const summary = useLoad(
        {
            url: '/main/market/summary',
            params: { ...filters },
        },
        [filters],
    )

    const summaryBuilding = useLoad(
        {
            url: '/main/building/summary',
            params: { ...filters },
        },
        [filters],
    )

    const financial = useLoad(
        {
            url: '/main/financial-summary',
            params: { ...filters },
        },
        [filters],
    )

    const expense = useLoad(
        {
            url: TECH_LIST,
            params: { ...filters },
        },
        [filters],
    )

    const handleFilterChange = (name, value) => {
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    const clearFilters = () => {
        setFilters({
            date_month: '',
            date_year: new Date().getFullYear(),
        })
    }

    const months = [
        { value: 1, label: 'Янvar' },
        { value: 2, label: 'Fevral' },
        { value: 3, label: 'Mart' },
        { value: 4, label: 'Aprel' },
        { value: 5, label: 'May' },
        { value: 6, label: 'Iyun' },
        { value: 7, label: 'Iyul' },
        { value: 8, label: 'Avgust' },
        { value: 9, label: 'Sentabr' },
        { value: 10, label: 'Oktabr' },
        { value: 11, label: 'Noyabr' },
        { value: 12, label: 'Dekabr' },
    ]
    const params = useParams()
    const chiqim = useLoad(
        {
            url: TOTAL_EXPENSE_LIST,
            params: { ...params }, // Add spaceType to API params
        },
        [params], // Add activeTab to dependencies
    )
    return (
        <Layout>
            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h1 className="title has-text-centered is-flex-grow-1">Умумий статистика</h1>
                {/* <Button text={showFilters ? 'Фильтрни ёпиш' : 'Фильтр'} className="button is-info is-outlined" onClick={() => setShowFilters(!showFilters)} /> */}
            </div>

            {/* Filter Section */}
            {showFilters && (
                <div className="box mb-4">
                    <h3 className="subtitle is-5 mb-3">Сана бўйича фильтр</h3>

                    <div className="columns">
                        <div className="column is-4">
                            <label className="label">Ой</label>
                            <div className="select is-fullwidth">
                                <select value={filters.date_month} onChange={(e) => handleFilterChange('date_month', e.target.value)}>
                                    <option value="">Барча ойлар</option>
                                    {months.map((month) => (
                                        <option key={month.value} value={month.value}>
                                            {month.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="column is-4">
                            <label className="label">Йил</label>
                            <input className="input" type="number" value={filters.date_year} onChange={(e) => handleFilterChange('date_year', e.target.value)} placeholder="Йилни киритинг" />
                        </div>

                        <div className="column is-4">
                            <label className="label">&nbsp;</label>
                            <div className="field">
                                <Button text="Фильтрни тозалаш" className="button is-light" onClick={clearFilters} />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h1 className="title">Дўконлар</h1>
            </div>
            <div className="columns is-mobile is-multiline">
                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0fff4',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-success has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-down-outline" />
                                <b className="ml-2">Кирим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(summary.response ? summary.response.totalIncomeSum : 0)} UZS</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#fff5f5',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-danger has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-up-outline" />
                                <b className="ml-2">Чиқим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(chiqim.response ? chiqim.response?.arendaTotal : 0)} Сум</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0f7ff',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-info has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="wallet-outline" />
                                <b className="ml-2">Баланс:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format((summary.response ? summary.response.totalIncomeSum : 0) - (chiqim.response ? chiqim.response?.arendaTotal : 0))} UZS</span>
                        </p>
                    </div>
                </div>
            </div>

            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h1 className="title">Домлар</h1>
            </div>

            <div className="columns is-mobile is-multiline">
                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0fff4',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-success has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-down-outline" />
                                <b className="ml-2">Кирим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(summaryBuilding.response ? summaryBuilding.response.totalIncomeSum : 0)} UZS</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#fff5f5',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-danger has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-up-outline" />
                                <b className="ml-2">Чиқим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(chiqim.response ? chiqim.response.domTotal : 0)} UZS</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0f7ff',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-info has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="wallet-outline" />
                                <b className="ml-2">Баланс:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format((summaryBuilding.response ? summaryBuilding.response.totalIncomeSum : 0) - (chiqim.response ? chiqim.response.domTotal : 0))} UZS</span>
                        </p>
                    </div>
                </div>
            </div>

            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h1 className="title">Бошқа</h1>
            </div>

            <div className="columns is-mobile is-multiline">
                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0fff4',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-success has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-down-outline" />
                                <b className="ml-2">Кирим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(expense.response ? expense.response.totalIncomeAmount : 0)} Сум</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#fff5f5',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-danger has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-up-outline" />
                                <b className="ml-2">Чиқим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(expense.response ? expense.response?.totalExpensesAmount : 0)} Сум</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0f7ff',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-info has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="wallet-outline" />
                                <b className="ml-2">Баланс:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format((expense.response ? expense.response.totalIncomeAmount : 0) - (expense.response ? expense.response?.totalExpensesAmount : 0))} Сум</span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h1 className="title">Умумий</h1>
            </div>

            <div className="columns is-mobile is-multiline">
                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0fff4',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-success has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-down-outline" />
                                <b className="ml-2">Кирим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(financial.response ? financial.response?.total.totalIncomeSum : 0)} Сум</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#fff5f5',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-danger has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="arrow-up-outline" />
                                <b className="ml-2">Чиқим:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(financial.response ? financial.response?.total?.totalExpensesSum : 0)} Сум</span>
                        </p>
                    </div>
                </div>

                <div className="column is-4-desktop is-12-mobile">
                    <div
                        style={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: '#f0f7ff',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                    >
                        <p className="has-text-info has-text-centered">
                            <span className="icon-text">
                                <ion-icon name="wallet-outline" />
                                <b className="ml-2">Баланс:</b>
                            </span>
                            <span className="ml-2 has-text-weight-bold">{format(financial.response ? financial.response?.total?.balance : 0)} Сум</span>
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
